// ==============================|| OVERRIDES - LIST ITEM BUTTON ||============================== //

export default function ListItemButton(theme) {
  return {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          color: '#64748B',
          paddingTop: '9px',
          paddingBottom: '9px',
          paddingLeft: '16px',
          borderRadius: '8px',
          margin: '2px 8px',
          transition: 'all 0.15s ease-in-out',

          '& .MuiListItemIcon-root': {
            color: '#64748B',
            minWidth: '32px',
            transition: 'color 0.15s ease-in-out'
          },

          '&.Mui-selected': {
            color: '#0D9488',
            backgroundColor: '#F0FDFA',
            borderLeft: '3px solid #14B8A6',
            fontWeight: 500,
            '&:hover': {
              backgroundColor: '#CCFBF1'
            },
            '& .MuiListItemIcon-root': {
              color: '#0D9488'
            }
          },

          '&:hover': {
            backgroundColor: '#F8FAFC',
            color: '#1E293B',
            '& .MuiListItemIcon-root': {
              color: '#1E293B'
            }
          }
        }
      }
    }
  };
}
